import React, { useContext, useState, useEffect } from 'react';
import {
  Modal,
  Form,
  Input,
  DatePicker,
  Card,
  Divider,
  InputNumber,
  Switch,
  Descriptions,
  Typography,
  Button,
  message,
  Row,
  Col,
} from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { StoreContext } from '../store/index';
import { updateShift } from './api';
import { getDateFromTimestamp, copyText } from '../utils';

const { Paragraph, Title } = Typography;

function PaymentModal({ shift, open, onClose }) {
  const store = useContext(StoreContext);
  const {
    user: [user],
  } = store;

  const { price, players } = shift;

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const onFinish = async values => {
    onClose();
  };
  const onFinishFailed = values => {};

  return (
    <Modal
      title={`Total a pagar: ${price}€`}
      open={open}
      onOk={onClose}
      onCancel={onClose}>
      <Paragraph level={5}>
        Precio por jugador:
        {` ${price}€ `}
      </Paragraph>
      <Paragraph level={5}>
        Hacer un byzum al numero xxxx o transferencia a ESxxxx poniendo en la
        descripcion el siguiente mensaje:
      </Paragraph>
      <Row align="middle">
        <Col span={12}>
          <Title level={5}>{`${shift.id.slice(0, 5)} ${user.email}`}</Title>
        </Col>
        <Col span={11} offset={1}>
          <Button
            type="primary"
            loading={loading}
            shape="circle"
            icon={<CopyOutlined />}
            onClick={() =>
              copyText(`${shift.id.slice(0, 5)} ${user.email}`, message)
            }
          />
        </Col>
      </Row>
    </Modal>
  );
}

export default PaymentModal;
